import React from 'react';
import { Tree } from 'antd';
import {DirectoryTreeProps } from 'antd/lib/tree/DirectoryTree';

export type { DirectoryTreeProps }

const ProDirectoryTree: React.FC<DirectoryTreeProps> = (props) => {
  const { children, ...resProps } = props;

  return <Tree.DirectoryTree {...resProps}>{children}</Tree.DirectoryTree>;
};

export default ProDirectoryTree;
